define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/heading/_base",
	"csi/html",
	"csi/locale",
	"csi/utility/stringUtility",
	"csi/middleware/customView/customViewDataManagementService",
	"csi/middleware/inline/InlinePopupService",
	"csi/widget/ComboBox",
	"csi/widget/CheckedMultiSelectDropdown",
	"csi/widget/InlineTextarea",
	"csi/widget/ValidationTextBox",
	"csi/xml",
	"./Attribute",
], function(
	declare,
	_,
	csiHeading,
	html,
	locale,
	{
		formatStringValue,
		trimAndPurifyText,
	},
	{
		lessThanGreaterThanOps
	},
	{
		CONTROL_TYPE_TEXT_FIELD
	},
	ComboBox,
	CheckedMultiSelectDropdown,
	InlineTextarea,
	ValidationTextBox,
	xml,
	Attribute
) {

	return declare(Attribute, {
		defaultValue: "",
		nTextareaLines: 4,
		queryOps: csiHeading.QUERY_OPS[xml.ATTR_STRING],
		type: xml.ATTR_STRING,
		tagAction: "ActionString",

		/** @property {string} renderTitle - set title property so that even if rendered string is cut off, the full value will be in tooltip*/
		renderTitle: null,

		formatValue: function(/*Any*/value, /*String?*/fmt) {
			// summary: return string value
			return formatStringValue(value);
		},

		fromHtmlDynamic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/editNode) {
			// summary: return attribute value from edit control
			var value = this.inherited(arguments);

			return trimAndPurifyText(value, h.m_format);
		},

		/**
		 * @override
		 * returns attribute value from edit control, this is to support the MultiSelect widget in form
		 */
		fromHtmlQueryFilter(ctx, spec, editNode, op) {
			return editNode.get("externalValue") || editNode.get("value");
		},

		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			// summary: render value for attribute in HTML
			var value = this.toValue(ctx, h);
			if (value) {
				this._toHtmlString(value, refNode, !ctx.bPrint);
				return true;
			}

			return false;
		},

		toHtmlDynamic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*Object*/params) {
			// summary: render editable	control for attribute
			params.bHandleEnter = false;

			if (params.value == null) {
				params.value = this._getValue(ctx, h);
			}

			if (ctx.defView.getType() == "Form") {
				return new ValidationTextBox(params);
			}

			return new InlineTextarea(params);
		},

		/**
		 * @override
		 * @param {Context} ctx 
		 * @param {Spec} spec 
		 * @param {DOMNode} refNode 
		 * @param {Object} params 
		 * @param {string} op 
		 * @returns widget based on attribute type and operator
		 */
		toHtmlQueryFilter(ctx, spec, refNode, params, op) {
			if (spec.querySpec.allowFilteringBySelectionOfExistingValues) {
				if (op === xml.OP_EQUALS || op === xml.OP_NOT_EQUALS) {
					return params.store ? new ComboBox(params) : this.inherited(arguments);
				} else if (op === xml.OP_CONTAINS || op === xml.OP_NOT_CONTAINS) {
					return new CheckedMultiSelectDropdown({
						addNewItem: spec.canFilterByOperator(xml.OP_MATCHES),
						...params,
					});
				} else if (op === xml.OP_MATCHES || op === xml.OP_NOT_MATCHES) {
					return new ValidationTextBox(params);
				}
			}
			return new ValidationTextBox(params);

		},

		/**
		 * @override
		 * If the feature flag "restore select input type for equals operator" is true, change the input type of string with multi line text or no format to single select instead of text field in custom view.
		 */
		getQuerySpec: function(ctx, h, spec) {
			var qs = this.inherited(arguments);
			qs.allowFilteringBySelectionOfExistingValues = h.m_id === xml.ATTR_NAME || csiHeading.restoreSelectInputForEqualsOperators;
			return qs;
		},

		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: handle name specially; otherwise use default to get attribute value
			return (h.m_id == xml.ATTR_NAME) ? locale.getNodePropertyName(ctx.getNode(), ctx.cache) : this.inherited(arguments);
		},

		_toHtmlString: function(/*String*/value, /*DOMNode*/refNode, /*Boolean*/bCanLink) {
			// summary: render value for string
			if (this.renderTitle && value) {
				$(refNode).attr("title", value);
			}

			html.text(refNode, value);
		},

		/** React */

		/**
		 * @override
		 */
		getReactPlaceholderOptions: function(controller, ctx, h) {
			const {oldValue} = controller;
			return {
				value: oldValue,
			};
		},

		/**
		 * @override
		 * modify the operators based on restoreTextComparisonOperators
		 * string attributes with Node Name id will return ref operators
		 */
		onSetQuerySpecOperator(restoreTextComparisonOperators, operators, spec) {
			const newOperators = spec.key.id === xml.ATTR_NAME ? csiHeading.QUERY_OPS[xml.ATTR_REF] : operators;
			return restoreTextComparisonOperators ? [...newOperators, ...lessThanGreaterThanOps] : newOperators;
		},

		/**
		 * @override
		 * @param {context} ctx
		 * @return {string}
		 */
		getReactControlType: function(ctx) {
			return CONTROL_TYPE_TEXT_FIELD;
		},

		/** 
		 * @override
		 * return true if react renderer exists for given attribute type and should be used
		 */
		useReactInlineDialog() {
			return false;
		},

	});
});